import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

import { ref, reactive } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'confirm-dialog',
  setup(__props, { expose: __expose }) {

const dialog = ref(false);
const message = ref<string | null>(null);
const title = ref<string | null>(null);
const options = reactive({
  color: 'grey lighten-3',
  width: 400,
  zIndex: 200,
  noconfirm: false,
});

let resolvePromise: ((v: boolean) => void) | null = null;

const open = (titleText: string | null, msg: string, opts: any): Promise<boolean> => {
  dialog.value = true;
  title.value = titleText;
  message.value = msg;
  Object.assign(options, opts);
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
};

const openWithMessage = (msg: string) => {
  return open(null, msg, {});
};

const agree = () => {
  if (resolvePromise) resolvePromise(true);
  dialog.value = false;
};

const cancel = () => {
  if (resolvePromise) resolvePromise(false);
  dialog.value = false;
};

__expose({ open, openWithMessage });

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    "max-width": options.width,
    onKeydown: _withKeys(cancel, ["esc"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: options.color,
            density: "compact"
          }, {
            default: _withCtx(() => [
              (title.value)
                ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                    key: 0,
                    class: "text-body-2 font-weight-bold text-grey"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (!title.value)
                ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                    key: 1,
                    class: "text-body-2 font-weight-bold text-grey"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.defaultTitle')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["color"]),
          _withDirectives(_createVNode(_component_v_card_text, {
            class: "pa-4 text-black",
            innerHTML: message.value
          }, null, 8 /* PROPS */, ["innerHTML"]), [
            [_vShow, !!message.value]
          ]),
          _createVNode(_component_v_card_actions, { class: "pt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              (!options.noconfirm)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "grey",
                    variant: "outlined",
                    class: "body-2 font-weight-bold",
                    onClick: cancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.cancel')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "body-2 font-weight-bold",
                variant: "flat",
                onClick: agree
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.ok')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "max-width"]))
}
}

})